import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import {Pagination as PaginationControl} from '@ey/canvascoreservices';
import {pagingOptions} from '../../../util/uiconstants';
import {currentResource, labels} from '../../../util/utils';
import Utility from '../../../util/utilityfunctions';

export default function Pagination({
	optionsPerPage,
	page,
	pageSize,
	pageCount,
	disabled,
	onPageSizeChanged,
	onPageSizeChange,
	onDropdownChange,
	onPageChanged,
	className
}) {
	const [itemsPerPage, setItemsPerPage] = React.useState(pageSize);
	return (
		<StyledPagination
			optionsPerPage={optionsPerPage}
			page={page || 1}
			pageSize={itemsPerPage}
			onPageSizeChanged={(size) => {
				setItemsPerPage(size);
				onPageSizeChanged && onPageSizeChanged(size);
				onPageSizeChange && onPageSizeChange(size);
				onDropdownChange && onDropdownChange(size);
			}}
			pageCount={pageCount}
			disabled={disabled}
			onPageChanged={onPageChanged}
			className={className}
			paginationButtonLabels={currentResource.pagingSvgHoverText}
			paginationSelectLabel={labels.pagingShowtext}
			theme={Utility.getTheme()}
		/>
	);
}

Pagination.propTypes = {
	optionsPerPage: PropTypes.arrayOf(PropTypes.number),
	page: PropTypes.number,
	pageSize: PropTypes.number,
	pageCount: PropTypes.number,
	disabled: PropTypes.bool,
	onPageSizeChanged: PropTypes.func,
	onPageChanged: PropTypes.func,
	className: PropTypes.string
};

Pagination.defaultProps = {
	optionsPerPage: pagingOptions
};

// Add default styling for Kronos / FIT
const StyledPagination = styled(PaginationControl)`
	.motif-pagination-list {
	li:first-child {
		font-size: var(--px-14);
	}
`;
